import { createSlice } from '@reduxjs/toolkit';

import { startAppListening } from 'src/store/middleware/listenerMiddleware';
import { dexVaultsApiEndpoints } from '@skynet/data-dex-vaults';

import type { UpdateVaultArg } from '@skynet/data-dex-vaults';
import type { DexState } from 'src/store/DEX/Vaults/types';

const initialState: DexState = {
  index: {
    isSidebarOpen: false,
    targetVault: null,
  },
  sortKey: 'created_desc',
  searchInput: '',
  autoUpdate: true,
  modal: {
    isOpen: false,
    selectedVault: undefined,
  },
};

export const vaultsSlice = createSlice({
  name: 'vaults',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.index.isSidebarOpen = !state.index.isSidebarOpen;
    },
    setTargetVault: (state, action: { payload: string | null }) => {
      state.index.targetVault = action.payload;
    },
    setSortKey: (state, action: { payload: string }) => {
      state.sortKey = action.payload;
    },
    setSearchInput: (state, action: { payload: string }) => {
      state.searchInput = action.payload;
    },
    openVaultModal: (
      state,
      action: { payload: UpdateVaultArg['updateVaultRequest'] | undefined },
    ) => {
      state.modal.selectedVault = action.payload;
      state.modal.isOpen = true;
    },
    closeVaultModal: (state) => {
      state.modal.isOpen = false;
      state.modal.selectedVault = undefined;
    },
    setAutoUpdate: (state, action: { payload: boolean }) => {
      state.autoUpdate = action.payload;
    },
  },
});

startAppListening({
  matcher: dexVaultsApiEndpoints.listVaults.matchFulfilled,
  effect: (action, listenerApi) => {
    const currentTarget = listenerApi.getState().dex.vaults.index.targetVault;
    if (currentTarget !== null) return;

    const { payload } = action;
    const vaults = payload.data.data;
    if (vaults && vaults.length > 0) {
      listenerApi.dispatch(vaultsActions.setTargetVault(String(vaults[0].id)));
    }
  },
});

export const { actions: vaultsActions } = vaultsSlice;
export default vaultsSlice.reducer;
